// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  matchId: __t.string().name("match_id"),
  persistentId: __t.option(__t.string()).name("persistent_id"),
  armyIndex: __t.u32().name("army_index"),
  archetype: __t.string(),
  name: __t.string(),
  experience: __t.u32(),
  troopsPercent: __t.f64().name("troops_percent"),
  skillsJson: __t.string().name("skills_json"),
  x: __t.f64(),
  y: __t.f64(),
  facing: __t.f64(),
  state: __t.string(),
  stance: __t.string(),
  marching: __t.bool(),
  strength: __t.f64(),
  maxStrength: __t.f64().name("max_strength"),
  morale: __t.f64(),
  maxMorale: __t.f64().name("max_morale"),
  isGeneral: __t.bool().name("is_general"),
  level: __t.u32(),
  attack: __t.f64(),
  defense: __t.f64(),
  attackSkill: __t.f64().name("attack_skill"),
  defenseSkill: __t.f64().name("defense_skill"),
  armor: __t.f64(),
  speed: __t.f64(),
  agility: __t.f64(),
  chargeBonus: __t.f64().name("charge_bonus"),
  bracingBonus: __t.f64().name("bracing_bonus"),
  mass: __t.f64(),
  isRanged: __t.bool().name("is_ranged"),
  rangedAttack: __t.f64().name("ranged_attack"),
  rangedDefense: __t.f64().name("ranged_defense"),
  shield: __t.f64(),
  ammo: __t.u32(),
  maxAmmo: __t.u32().name("max_ammo"),
  fireRateTicks: __t.u32().name("fire_rate_ticks"),
  fireArcHalfAngle: __t.f64().name("fire_arc_half_angle"),
  canFireWhileMoving: __t.bool().name("can_fire_while_moving"),
  rangedAccuracy: __t.f64().name("ranged_accuracy"),
  projectileCount: __t.u32().name("projectile_count"),
  projectileType: __t.string().name("projectile_type"),
  category: __t.string(),
  symbol: __t.string(),
  engagementIds: __t.string().name("engagement_ids"),
  currentOrderJson: __t.option(__t.string()).name("current_order_json"),
  pendingOrderJson: __t.option(__t.string()).name("pending_order_json"),
  orderQueueJson: __t.string().name("order_queue_json"),
  targetFacing: __t.option(__t.f64()).name("target_facing"),
  breakTimer: __t.u32().name("break_timer"),
  breakTargetEngagementId: __t.option(__t.string()).name("break_target_engagement_id"),
  routeTimer: __t.u32().name("route_timer"),
  recoveryTimer: __t.u32().name("recovery_timer"),
  routeDirection: __t.f64().name("route_direction"),
  routePhase: __t.u32().name("route_phase"),
  retreatTargetX: __t.option(__t.f64()).name("retreat_target_x"),
  retreatTargetY: __t.option(__t.f64()).name("retreat_target_y"),
  lastPositionX: __t.option(__t.f64()).name("last_position_x"),
  lastPositionY: __t.option(__t.f64()).name("last_position_y"),
  chargeDistanceAccumulated: __t.f64().name("charge_distance_accumulated"),
  suppressed: __t.bool(),
  suppressionHitsJson: __t.string().name("suppression_hits_json"),
  suppressionClearTimer: __t.u32().name("suppression_clear_timer"),
  followMode: __t.bool().name("follow_mode"),
  fireCooldown: __t.u32().name("fire_cooldown"),
  fireTargetId: __t.option(__t.string()).name("fire_target_id"),
  volleyRemaining: __t.u32().name("volley_remaining"),
  volleyTargetId: __t.option(__t.string()).name("volley_target_id"),
  rangedStance: __t.string().name("ranged_stance"),
  fireRange: __t.f64().name("fire_range"),
  visionRange: __t.f64().name("vision_range"),
  reinforcedSides: __t.u32().name("reinforced_sides"),
  chainFrontUnitId: __t.option(__t.string()).name("chain_front_unit_id"),
  chainRearUnitId: __t.option(__t.string()).name("chain_rear_unit_id"),
  idleStance: __t.string().name("idle_stance"),
  guardPointX: __t.option(__t.f64()).name("guard_point_x"),
  guardPointY: __t.option(__t.f64()).name("guard_point_y"),
  guardRadius: __t.f64().name("guard_radius"),
  guardTargetId: __t.option(__t.string()).name("guard_target_id"),
  aggressiveTargetId: __t.option(__t.string()).name("aggressive_target_id"),
  rankLevel: __t.u32().name("rank_level"),
  matchDamageDealt: __t.f64().name("match_damage_dealt"),
  matchKills: __t.u32().name("match_kills"),
  matchRoutsCaused: __t.u32().name("match_routs_caused"),
  matchTicksEngaged: __t.u32().name("match_ticks_engaged"),
  stanceCooldownTicks: __t.u32().name("stance_cooldown_ticks"),
  hasPendingOrder: __t.bool().name("has_pending_order"),
  currentOrderType: __t.string().name("current_order_type"),
  fatigue: __t.f64(),
  fatigueBuildupMultiplier: __t.f64().name("fatigue_buildup_multiplier"),
  fatigueRecoveryMultiplier: __t.f64().name("fatigue_recovery_multiplier"),
  fireAtWill: __t.bool().name("fire_at_will"),
  formationShape: __t.option(__t.string()).name("formation_shape"),
  perSoldierArea: __t.f64().name("per_soldier_area"),
  qualityTier: __t.u32().name("quality_tier"),
  shockResistance: __t.f64().name("shock_resistance"),
  troopsMax: __t.u32().name("troops_max"),
  troopsAlive: __t.u32().name("troops_alive"),
  troopKills: __t.u32().name("troop_kills"),
  builderEnabled: __t.bool().name("builder_enabled"),
  builderSeeking: __t.bool().name("builder_seeking"),
  attackSpeed: __t.u8().name("attack_speed"),
  meleeCooldown: __t.u32().name("melee_cooldown"),
  squadId: __t.option(__t.string()).name("squad_id"),
  squadSize: __t.u32().name("squad_size"),
  isCaptain: __t.bool().name("is_captain"),
  captainUnitId: __t.option(__t.string()).name("captain_unit_id"),
  testudoTimer: __t.u32().name("testudo_timer"),
  phalanxTimer: __t.u32().name("phalanx_timer"),
  coordinatedChargeTimer: __t.u32().name("coordinated_charge_timer"),
  huntSpotTimer: __t.u32().name("hunt_spot_timer"),
  panicCount: __t.u32().name("panic_count"),
  formationKind: __t.option(__t.string()).name("formation_kind"),
  soldierFrontageM: __t.f64().name("soldier_frontage_m"),
  soldierRankDepthM: __t.f64().name("soldier_rank_depth_m"),
  formationFiles: __t.u32().name("formation_files"),
  formationRanks: __t.u32().name("formation_ranks"),
  columnParentId: __t.option(__t.string()).name("column_parent_id"),
  columnIndex: __t.u32().name("column_index"),
  columnPhase: __t.option(__t.string()).name("column_phase"),
  columnDamageFraction: __t.f64().name("column_damage_fraction"),
  formationDataJson: __t.option(__t.string()).name("formation_data_json"),
  artilleryJson: __t.option(__t.string()).name("artillery_json"),
});
